export const WorksheetStatusBarTestIds = {
  BAR: 'worksheet-drawer.status-bar',
  LAST_SAVED: 'worksheet-drawer.status-bar.last-saved',
  CHIP: 'worksheet-drawer.status-bar.chip',
};
